import React from 'react';

import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import { getLayout } from 'src/layouts/SiteLayout/StaticPageLayout';
import { ArticleParagraph, ArticleSubtitle, ArticleTitle } from 'src/components/common';

const ArticleItem = () => {
  const { t } = useTranslation();

  return (
    <div className="animate__animated animate__fadeIn">
      <Head>
        <title>{t('pages.blog.how-to-use-website-traffic-booster-to-increase-profits.title')}</title>
        <meta
          name="description"
          content={t('pages.blog.how-to-use-website-traffic-booster-to-increase-profits.description')}
        />
      </Head>

      <ArticleTitle>Website Traffic Booster is a Tool for Those Who Appreciate Innovative Solutions</ArticleTitle>
      <ArticleParagraph>
        If you are developing a business in the direction of digital marketing, free traffic for website is very
        important. Many entrepreneurs in this segment of activity understand that the decision to buy real traffic your
        website will be promising and profitable in many ways. It makes it possible to increase the position of an
        Internet resource in search results. The better the site is indexed, the more people will see it. When you need
        free traffic online, the question immediately arises of how safe it is.
      </ArticleParagraph>

      <ArticleSubtitle>How to get visitors to your website for free</ArticleSubtitle>

      <ArticleParagraph>
        Many online business owners would like to get traffic to site for free in the most secure way possible. For such
        purposes, our team of specialists has developed a special traffic bot that really allows you to get traffic on
        your website free. When we developed this IT tool, we prioritized several important tasks. It was important for
        us to achieve a number of indicators:
      </ArticleParagraph>

      <ul>
        <li> improve the technical parameters of the site, which are displayed in Google Analytics;</li>
        <li> reduce failure rates;</li>
        <li> raise engagement parameters.</li>
      </ul>

      <ArticleParagraph>
        Such a systematic focus of this IT product allows you to achieve good results. When a site becomes more visible
        to search engines, it increases the chances that a new audience will come to your online resource. Free traffic
        for link is a good solution. And now let's talk a few words about our team, which developed a bot program that
        can generate internet traffic.
      </ArticleParagraph>

      <ArticleSubtitle>About Us</ArticleSubtitle>

      <ArticleParagraph>
        Our team is a team of like-minded people who do what they love and consider it promising. We try to study the
        current trends in our industry and navigate popular customer requests. This approach makes it possible to work
        efficiently and implement projects that are really able to meet the needs of customers. Thus, we regularly
        examine the analytics of our professional field and understand what it needs.
      </ArticleParagraph>
      <ArticleParagraph>
        Before starting work on a traffic bot, we studied what customers need in this direction. We understand how
        important it is for an Internet resource to have good technical performance. This is an important area that you
        need to focus on in parallel with the external and internal optimization of the online resource.
      </ArticleParagraph>

      <ArticleSubtitle>About our product</ArticleSubtitle>

      <ArticleParagraph>
        The bot for attracting traffic is offered in two versions. You can try the free version first to make sure that
        this tool is really promising and functional. There is also paid sign ups guaranteed targeted traffic. Such a
        subscription is provided in different tariff plans. It is offered to those clients who are focused on a really
        tangible result in the promotion of the site.
      </ArticleParagraph>
      <ArticleParagraph>
        We will help you make your resource work better and more efficiently. You just need to choose the right tariff
        plan. Here you should focus on the needs of your business. For example, the PRO tariff plan provides 800
        thousand views per month. It can be used for 2 active projects at once. A subscription to the Master tariff
        plan, which provides 300,000 views, is somewhat cheaper. It can be used for 1 project. This option is the most
        requested by our customers. But there are also more powerful subscription formats. For example, you might choose
        an option that gives your site 2.5 million page views per month.
      </ArticleParagraph>
      <ArticleParagraph>
        We have it all detailed on our website. You should only read the information and choose a tariff plan based on
        the needs of your business. And if you have any questions, you can contact the provided contact information.
      </ArticleParagraph>
    </div>
  );
};

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
}

ArticleItem.getLayout = (page) => getLayout(page);

export default ArticleItem;
